// MobileMarketerCard.jsx — 휴대폰 배정 탭의 마케터 한 장 (2026-10-06 UX 4단계)
//   머리를 누르면 접고 펴기. 펼치면 1:1 직원 줄(누르면 배정 상세 창) + [+ 직원 배정] [숨김].
import React from 'react';
import { periodText, ruleText, sortByToday, statusText, statusTone } from '../assignmentText';
import { M } from './mobile.styles';

export function MobileMarketerCard({ marketer, rows, today, open, onToggle, onOpenRow, onAdd, onHide }) {
  const sorted = sortByToday(rows, today);
  const upcoming = sorted.filter((row) => statusTone(row, today) === 'upcoming').length;
  return (
    <div style={M.card}>
      <button type="button" style={M.cardHead} onClick={onToggle} aria-expanded={open}>
        <span style={{ minWidth: 0 }}>
          <span style={{ ...M.cardName, display: 'block' }}>{marketer.name || '-'}</span>
          <span style={{ ...M.cardMeta, display: 'block' }}>1:1 직원 {sorted.length}명{upcoming ? ` · 시작 예정 ${upcoming}명` : ''}</span>
        </span>
        <span style={M.chevron} aria-hidden="true">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <>
          {sorted.length === 0 && <div style={M.emptyRow}>배정된 1:1 직원이 없어요.</div>}
          {sorted.map((row) => (
            <button key={row.id} type="button" style={M.row} onClick={() => onOpenRow(row)}>
              <span style={{ minWidth: 0 }}>
                <span style={{ ...M.rowName, display: 'block' }}>{row.consultant_name || '-'}</span>
                <span style={{ ...M.rowMeta, display: 'block' }}>{periodText(row)}</span>
                <span style={{ ...M.rowMeta, display: 'block' }}>{ruleText(row)}</span>
              </span>
              <span style={M.rowSide}>
                <span style={M.badge(statusTone(row, today))}>{statusText(row, today)}</span>
                <span style={M.chevron} aria-hidden="true">›</span>
              </span>
            </button>
          ))}
          <div style={M.cardFoot}>
            <button type="button" style={M.footBtn('blue')} onClick={() => onAdd(marketer)}>+ 직원 배정</button>
            <button type="button" style={M.footBtn()} onClick={() => onHide(marketer.id)}>숨김</button>
          </div>
        </>
      )}
    </div>
  );
}
